<template>
  <div>
    <b-input v-if="enableSearch" type="text" v-model="searchKey"></b-input>
    <ul :id="treeId" class="ztree card"></ul>
  </div>
</template>
<script>

import emUtils from "@/utils/emUtils";

export default {
  name: "EmZTree",
  props: {
    /**
     * 插件的数据源
     */
    treeNodes: {
      type: Array,
      required: true
    },
    sortField: {
      type: String,
      default: "seq"
    },
    sortDesc: {
      type: Boolean,
      default: false
    }
    ,
    /**
     * 是否启用多选框
     */
    checkEnable: {
      type: Boolean,
      default: false
    },
    /**
     * 选中id，设置了该属性后，它只要发生变化，emZTree就会自动变更当前选中项
     */
    selectedId: {
      type: [String, Number],
      default: ""
    },
    checkedIds: {
      type: String,
      default: ""
    },
    enableAutoExpandChecked: {
      type: Boolean,
      default: false
    },
    /**
     * 是否禁用单击展开，默认：false
     * 如果有这种情况：单击后如果会刷新某些数据，某些数据的刷新又会反过来触发刷新treeNodes（afterLoadRowsTrigger）
     * ，treeNodes刷新后，又会根据selectedId重新选中之前项目，重新选中之前项目又会展开子项目
     * 这里如果设置了ture，就会展开两次，看着就会怪怪的。menuList就是这样
     * 通过在store中增加了handleClicking字段，解决了该问题，单击时，先设置true，最后在设回false
     */
    clickExpandNodeDisable: {
      type: Boolean,
      default: false
    },
    /**
     * 树节点Id，如果有多棵树，记得要有不同的treeId
     */
    treeId: {
      type: String,
      default: "emZTree"
    },
    /**
     * 数据中，哪个字段作为节点text显示，默认name
     */
    textKeys: {
      type: String,
      default: "name"
    },
    /**
     * 数据中，哪个字段作为tree的id，默认：id
     */
    idKey: {
      type: String,
      default: "id"
    },
    /**
     * 数据中，哪个字段作为tree的pId，默认：parentId
     */
    pIdKey: {
      type: String,
      default: "parentId"
    },
    /**
     * 数据中，哪个字段作为title（鼠标悬停显示），默认：remark
     */
    titleKey: {
      type: String,
      default: "remark"
    },
    /**
     * 数据中，哪个字段作为url，可以点击跳转的那种，默认：nodeUrl
     */
    urlKey: {
      type: String,
      default: "nodeUrl"
    },
    /**
     * 是否启用搜索，默认禁用
     */
    enableSearch: {
      type: Boolean,
      default: false
    },
    /**
     * 是否根据filter搜索，默认false，根据name模糊查询
     */
    searchNodesByFilter: {
      type: Boolean,
      default: false
    },
    /**
     * 搜索时的高亮显示样式，默认是byClass，设为false就是byCss
     */
    styleNodesByClass: {
      type: Boolean,
      default: true
    },
    /**
     * 自动展开至第几层，默认从0开始，代表第一层
     */
    expandLevel: {
      type: Number,
      default: 0
    },
    chkboxType: {
      default: () => {
        return {"Y": "ps", "N": "ps"}
      }
    },
    nodeAppender: {
      type: Function,
      default: null
    },
    addDiyDom: {
      type: Function,
      default: null
    },
    /**
     * 是否支持多选
     */
    multiSelect: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      searchKey: "",
      zTreeObj: $.fn.zTree.getZTreeObj(this.treeId),
      searchResultNodes: [],
      setting: {
        check: {
          enable: this.checkEnable,
          autoCheckTrigger: !this.multiSelect, //跟随父节点自动被选中或取消选中的子节点，会不会触发beforeCheck和check, 默认false
          chkDisabledInherit: true,   //父节点禁止选中，子节点也禁止选中
          chkStyle: !this.multiSelect ? "radio" : "checkbox",//值为checkbox或者radio表示
          chkboxType: this.chkboxType //auto check 父节点 子节点，默认值就是这个
        },
        data: {
          key: {
            title: this.titleKey,
            url: this.urlKey,
            name: this.textKeys
          },
          simpleData: {
            enable: true,
            idKey: this.idKey,
            pIdKey: this.pIdKey,
            // rootPId: ".0."
          }
        },
        callback: {
          //通过beforeClick事件，可以让设置了【click:false】的数据节点的onClick事件被拒绝
          beforeClick: (treeId, treeNode, clickFlag) => {
            // console.log("[ "+getTime()+" beforeClick ]&nbsp;&nbsp;" + treeNode.name );
            return (treeNode.click !== false);
          },
          //clickFlag: 0:取消选中，1：普通选中，2：追加选中
          onClick: (event, treeId, treeNode, clickFlag) => {
            // console.log("[ "+getTime()+" onClick ]&nbsp;&nbsp;clickFlag = " + clickFlag + " (" + (clickFlag===1 ? "普通选中": (clickFlag===0 ? "<b>取消选中</b>" : "<b>追加选中</b>")) + ")");

            //单击展开
            if (!this.clickExpandNodeDisable) {
              var zTree = $.fn.zTree.getZTreeObj(this.treeId);
              //单击永远是展开，想要折叠，自己点前面的减号去
              zTree.expandNode(treeNode, true);
            }

            this.$emit("onclick", event, treeId, treeNode, clickFlag);
            // console.log("debug 001 :EmZTreeOnclick")
          },
          onCollapse: (e, treeId, treeNode) => {
            //byCss就直接返回
            if (!this.styleNodesByClass) return;
            this.updateNodes(false, treeNode);
            this.updateNodes(true, treeNode)
          },
          onExpand: (e, treeId, treeNode) => {
            //byCss就直接返回
            if (!this.styleNodesByClass) return;
            this.updateNodes(false, treeNode);
            this.updateNodes(true, treeNode)
          }
        },
        view: {
          //暂时不考虑多选，好像没啥需求，还捣乱
          selectedMulti: false,
          fontCss: (treeId, treeNode) => {
            return !this.styleNodesByClass
                ? ((!treeNode.highlight) ? {color: "#A60000", "font-weight": "bold"} : {
                  color: "#333",
                  "font-weight": "normal"
                })
                : {color: "#333", "font-weight": "normal"};
          },
          addDiyDom: this.addDiyDom
        }
      }
    }
  },
  computed: {
    checkSetting() {
      if (this.multiSelect) {
        console.log("进1了")
        return {
          enable: this.checkEnable,
          chkDisabledInherit: true,   //父节点禁止选中，子节点也禁止选中
          chkboxType: this.chkboxType //auto check 父节点 子节点，默认值就是这个
          // autoCheckTrigger: true   //跟随父节点自动被选中或取消选中的子节点，会不会触发beforeCheck和check, 默认false
        }
      }
      //通过取消父子节点联动，设置节点的选择框为radio单选框，来实现ztree的单选，设了这个chkboxType的props就失效了
      else {
        console.log("进2了")
        return {
          enable: this.checkEnable, //是否显示radio/checkbox
          autoCheckTrigger: false,
          chkStyle: "radio",//值为checkbox或者radio表示
          radioType: "all",
          chkboxType: {"Y": "", "N": ""}//表示父子节点的联动效果，不联动
        };
      }
    }
  },
  watch: {
    treeNodes() {
      this.freshArea()
      //每次刷新数据后，重新选中之前选中的节点
      this.selectNodeById(this.selectedId)
      this.checkNodes();
    },
    selectedId(newValue, oldValue) {
      this.selectNodeById(newValue)
    },
    checkedIds() {
      this.checkNodes();
    },
    searchKey() {
      this.searchNode()
    },
    styleNodesByClass() {
      this.resetTree()
    },
    chkboxType: {
      handler() {
        let zTreeObj = $.fn.zTree.getZTreeObj(this.treeId);
        this.$set(zTreeObj.setting.check, "chkboxType", this.chkboxType);
      },
      deep: true
    }
  },
  methods: {
    getCheckedNodes() {
      let zTree = $.fn.zTree.getZTreeObj(this.treeId);
      return zTree.getCheckedNodes(true)
    },
    //根据id设置选中
    selectNodeById(id) {
      //取得zTree对象
      var zTree = $.fn.zTree.getZTreeObj(this.treeId)
      let selectedNodes = zTree.getSelectedNodes()
      //如果已经是当前选中了，就直接返回
      if (selectedNodes.length > 0 && selectedNodes.some(node => node.id === id)) {
        return
      }
      //根据id查询出node，返回数组对象，第三个参数是parentNode（JSON),可以指定在某个父节点下的子节点中搜索
      let node = zTree.getNodesByParam("id", id, null)
      //如果查到了，就选中第一项
      if (node.length > 0) {
        //第二个参数默认false，如果传true，就是追加选中
        //第三个参数默认false，会让节点自动滚动到可视区域内，true就不自动滚动了
        zTree.selectNode(node[0]);
        //自动展开
        zTree.expandNode(node[0], true);
      }
      console.log("debug 001 :selectNodeById")
    },
    freshArea() {
      this.initTree()
    },
    initTree() {
      // 先排序
      let sortedTreeNodesData = this.treeNodes.concat().sort((a, b) => {
        let aField = a[this.sortField]
        let bField = b[this.sortField]
        if (aField !== undefined && bField !== undefined) {
          return this.sortDesc ? bField - aField : aField - bField
        }
        return 0
      })
      $.fn.zTree.init($("#" + this.treeId), this.setting, sortedTreeNodesData);
      //如果有nodeAppender函数，就执行
      if (emUtils.isFunction(this.nodeAppender)) {
        this.appendAndRefreshTreeNodes();
      }
      this.expandByLevel(this.expandLevel)
    },
    appendAndRefreshTreeNodes() {
      let zTree = $.fn.zTree.getZTreeObj(this.treeId);
      let zTreeNodes = zTree.getNodes()
      this.nodesRecursionAppender(zTreeNodes);
      zTree.refresh()
    },
    //递归调用props传进来的nodeAppender函数，对树节点进行渲染
    nodesRecursionAppender(zTreeNodes) {
      //先循环
      for (let i = 0; i < zTreeNodes.length; i++) {
        //循环过程中，判断，如果有children，就把children作为参数递归调用自己
        if (zTreeNodes[i].isParent) {
          this.nodesRecursionAppender(zTreeNodes[i].children)
        }
        //appender放在递归调用的下面，可以保证nodes是自底向上appender的，这样刷新父节点时，子节点已经是appender好了的
        zTreeNodes[i] = this.nodeAppender(zTreeNodes[i])
      }
    },
    //搜索
    searchNode(e) {
      let zTree = $.fn.zTree.getZTreeObj(this.treeId);
      if (!this.searchNodesByFilter) {
        let value = this.searchKey;
        let keyType = "name";
        // if ($("#name").attr("checked")) {
        //     keyType = "name";
        // } else if ($("#level").attr("checked")) {
        //     keyType = "level";
        //     value = parseInt(value);
        // } else if ($("#id").attr("checked")) {
        //     keyType = "id";
        //     value = parseInt(value);
        // }

        // todo : 这里还没太理解，先放着
        // if (key.hasClass("empty")) {
        //     value = "";
        // }

        //因为vue双向绑定了，就不用lastValue了吧？
        // if (lastValue === value) return;
        // lastValue = value;

        this.updateNodes(false);
        if (value === "") return;

        //目前指定搜索name
        // if ($("#getNodeByParam").attr("checked")) {
        //     var node = zTree.getNodeByParam(keyType, value);
        //     if (node === null) {
        //         nodeList = [];
        //     } else {
        //         nodeList = [node];
        //     }
        // } else if ($("#getNodesByParam").attr("checked")) {
        //     nodeList = zTree.getNodesByParam(keyType, value);
        // } else if ($("#getNodesByParamFuzzy").attr("checked")) {
        this.searchResultNodes = zTree.getNodesByParamFuzzy(keyType, value);
        // }
      } else {
        this.updateNodes(false);
        this.searchResultNodes = zTree.getNodesByFilter(this.filter);
      }
      this.updateNodes(true);

    },
    //更新nodes样式
    updateNodes(highlight, node = null) {
      let zTree = $.fn.zTree.getZTreeObj(this.treeId);
      let applyClasses = this.styleNodesByClass
      let expanded = node && node.open;

      // If expanding a node then it MUST be a parent
      // in which case it cannot be hiding matched nodes
      if (applyClasses && expanded) {
        node.hiddenNodes = false;
        zTree.updateNode(node);
      }
      for (let i = 0, l = this.searchResultNodes.length; i < l; i++) {
        this.searchResultNodes[i].highlight = highlight;
        this.searchResultNodes[i].hiddenNodes = false;
        if (applyClasses && highlight) {
          // Make parent nodes of matched nodes show the
          // existence of hidden nodes if the parent is closed.
          let searchResultNode = this.searchResultNodes[i];
          while (true) {
            if (!searchResultNode.parentTId) break;
            let parentNode = zTree.getNodeByTId(searchResultNode.parentTId);
            if (parentNode.isParent && parentNode.open) break;
            parentNode.hiddenNodes = true;
            zTree.updateNode(parentNode);
            searchResultNode = parentNode;
          }
        }
        zTree.updateNode(this.searchResultNodes[i]);
      }
    },
    filter(node) {
      return !node.isParent && node.isFirstNode;
    },
    expandByLevel(level) {
      let zTree = $.fn.zTree.getZTreeObj(this.treeId);
      let nodes = zTree.getNodesByParam("level", level)
      if (nodes.length > 0) {
        for (var i = 0; i < nodes.length; i++) {
          zTree.expandNode(nodes[i], true)
        }
      }
    },
    resetTree(e) {
      if (!this.styleNodesByClass) {
        this.setting.view.fontCss = (treeId, treeNode) => {
          return !this.styleNodesByClass
              ? ((treeNode.highlight) ? {color: "#A60000", "font-weight": "bold"} : {
                color: "#333",
                "font-weight": "normal"
              })
              : {color: "#333", "font-weight": "normal"};
        }
        this.setting.view.nodeClasses = ""
      } else {
        this.setting.view.fontCss = ""
        this.setting.view.nodeClasses = (treeId, treeNode) => {
          let classes = !this.styleNodesByClass || !(!!treeNode.highlight || !!treeNode.hiddenNodes)
              ? {remove: ['highlight', 'highlight_alt', 'hiddennodes', 'highlight_hiddennodes']}
              : (treeNode.highlight
                      ? ((treeNode.hiddenNodes)
                              ? {add: ['highlight', 'highlight_alt', 'hiddennodes']}
                              : {add: ['highlight', 'highlight_alt']}
                      )
                      : {add: ['hiddennodes', 'highlight_alt']}
              );
          return classes;
        }
      }
      this.initTree()
      this.searchNode()
    },
    checkNodes() {
      let tempList = this.checkedIds.split(",");
      let zTree = $.fn.zTree.getZTreeObj(this.treeId);
      let nodes = zTree.getNodesByFilter(node => {
        return tempList.some(id => node.id === id || Number.parseInt(id) === node.id);
      });
      for (let node of nodes) {
        zTree.checkNode(node, true);
        if (this.enableAutoExpandChecked) {
          zTree.expandNode(node, true);
        }
      }
    }
  },
  mounted() {
    this.resetTree()
  }
}

function getTime() {
  let now = new Date(),
      h = now.getHours(),
      m = now.getMinutes(),
      s = now.getSeconds();
  return (h + ":" + m + ":" + s);
}
</script>
<style>
@import '../../../plugins/zTree/css/zTreeStyle/zTreeStyle.css';
@import '../../../plugins/font-awesome-4.7.0/css/font-awesome.css';

.ztree li span {
  position: relative;
}

.ztree li > a.highlight_alt {
  color: #00A600;
  font-weight: bold;
}

.ztree li > a.highlight span.node_name:before,
.ztree li > a.highlight_hiddennodes span.node_name:before,
.ztree li > a.hiddennodes span.node_name:before {
  font-family: FontAwesome;
  color: green;
  font-size: 14px;
  position: absolute;
  left: 100%;
  margin-left: 8px;
}

.ztree li > a.highlight span.node_name:before {
  content: '\f058';
}

.ztree li > a.hiddennodes span.node_name:before {
  content: '\f00e';
}

.ztree li > a.highlight.hiddennodes span.node_name:before {
  content: '\f058  \f00e';
}

#areaTree {
  border: 1px solid #e5e5e5;
  margin-bottom: 2px;
  border-radius: 4px;
  overflow: hidden;
}

.box-title {
  border-radius: 3px 3px 0 0;
  background-color: #f5f5f5;
}

.box-title a {
  color: #2fa4e7;
  text-decoration: none;
  font-size: 14px;
  display: block;
  padding: 8px 15px;
  cursor: pointer;
}

.box-title .fa {
  float: right;
  line-height: 20px;
}

/*todo icon的css显示有问题*/
.ztree li span.button.iconUser_ico_docu {
  margin-right: 2px;
  background: url(../../../plugins/zTree/css/zTreeStyle/img/diy/user.png) no-repeat scroll 0 0 transparent;
  vertical-align: top;
  *vertical-align: middle
}

.ztree li span.button.iconBuilding_ico_docu {
  margin-right: 2px;
  background: url(../../../plugins/zTree/css/zTreeStyle/img/diy/building.png) no-repeat scroll 0 0 transparent;
  vertical-align: top;
  *vertical-align: middle
}

.ztree li span.button.pIconBuilding_ico_open {
  margin-right: 2px;
  background: url(../../../plugins/zTree/css/zTreeStyle/img/diy/building_delete.png) no-repeat scroll 0 0 transparent;
  vertical-align: top;
  *vertical-align: middle
}

.ztree li span.button.pIconBuilding_ico_close {
  margin-right: 2px;
  background: url(../../../plugins/zTree/css/zTreeStyle/img/diy/building_add.png) no-repeat scroll 0 0 transparent;
  vertical-align: top;
  *vertical-align: middle
}

.ztree li span.button.minus1_ico_docu {
  margin-right: 2px;
  background: url(../../../plugins/zTree/css/zTreeStyle/img/diy/minus1.png) no-repeat scroll 0 0 transparent;
  vertical-align: top;
  *vertical-align: middle
}

.ztree li span.button.minus1_ico_open {
  margin-right: 2px;
  background: url(../../../plugins/zTree/css/zTreeStyle/img/diy/minus1.png) no-repeat scroll 0 0 transparent;
  vertical-align: top;
  *vertical-align: middle
}

.ztree li span.button.minus1_ico_close {
  margin-right: 2px;
  background: url(../../../plugins/zTree/css/zTreeStyle/img/diy/minus1.png) no-repeat scroll 0 0 transparent;
  vertical-align: top;
  *vertical-align: middle
}


</style>
